
import { IFacility } from "@/models/facility";
import $API from "@/services";
import { defineComponent, onMounted, reactive } from "vue";
import PageFrame from "@/components/common/PageFrame.vue";
import HospitalItem from "@/components/facility/HospitalItem.vue";
import { useI18n } from "vue-i18n";

export default defineComponent({
  emits: ["selected"],
  setup(props, { emit }) {
    const {t} = useI18n();

    const state = reactive({
      hospitalList: [] as Array<IFacility>,
    });

    const SelectedHospital = (key: number) => {
      emit("selected", key);
    };

    onMounted(async () => {
      try {
        const hospitalList = await $API.FacilityService.getHospitalList();
        if(Array.isArray(hospitalList)) {
          state.hospitalList = hospitalList;
        }
        console.log(hospitalList, 'onMounted.hospitalList');
      } catch(ex) {
        console.error(ex);
      }

      // 병원이 하나 밖에 없으면 병원 선택 없이 해당 병원 자동 선택
      if (state.hospitalList && state.hospitalList.length === 1)
        SelectedHospital(state.hospitalList[0].FacilityKey.valueOf());
    });

    return { state, SelectedHospital, t };
  },
  components: {
    PageFrame,
    HospitalItem,
  },
});
